import AppContext from '../../context/AppContext'

import Header from '../Header'
import SideBar from '../SideBar'

import {
  NotFoundContainer,
  NotFoundImg,
  NotFoundTitle,
  NotFoundPara,
} from './styledComponents'

const NotFound = () => (
  <AppContext.Consumer>
    {value => {
      const {theme} = value

      return (
        <div data-testid="notFound">
          <Header />
          <SideBar />
          <NotFoundContainer theme={theme}>
            {theme === true ? (
              <NotFoundImg
                src="https://assets.ccbp.in/frontend/react-js/nxt-watch-not-found-dark-theme-img.png"
                alt="not found"
              />
            ) : (
              <NotFoundImg
                src="https://assets.ccbp.in/frontend/react-js/nxt-watch-not-found-light-theme-img.png"
                alt="not found"
              />
            )}
            <NotFoundTitle theme={theme}>Page Not Found</NotFoundTitle>
            <NotFoundPara theme={theme}>
              we are sorry, the page you requested could not be found.
            </NotFoundPara>
          </NotFoundContainer>
        </div>
      )
    }}
  </AppContext.Consumer>
)

export default NotFound
